<template>
  <div class="dashboard-container">
    <div class="container--card block--actions">
      <div class="title">
        <h4>{{ $t('interface.actions') }}</h4>
      </div>
      <div class="buttons">
        <button-send-tx :go-to="goTo" class="clickable" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import tabsConfig from '../../components/InterfaceSideMenu/InterfaceSideMenu.config';
import dapps from '@/dapps';
import ButtonSendTx from './components/ButtonSendTx';

import { SwapProviders, providers } from '@/partners';
import BigNumber from 'bignumber.js';

const toBigNumber = num => {
  return new BigNumber(num);
};

export default {
  components: {
    'button-send-tx': ButtonSendTx
  },
  props: {
    tokensWithBalance: {
      type: Array,
      default: function() {
        return [];
      }
    },
    getBalance: {
      type: Function,
      default: function() {}
    },
    highestGas: {
      type: String,
      default: '0'
    }
  },
  data() {
    return {
      showSwapValues: true,
      dappsToShow: ['maker', 'manageEns', 'scheduleTransaction'],
      tabData: tabsConfig.tabs,
      advancedExpand: false,
      isValidAddress: false,
      hexAddress: '',
      address: '',
      value: '0',
      gasLimit: '21000',
      data: '',
      selectedCurrency: '',
      ethPrice: 0,
      swapPairs: [
        { from: 'ETH', to: 'BTC', amt: 1, rate: 0 },
        { from: 'ETH', to: 'EUR', amt: 1, rate: 0 },
        { from: 'ETH', to: 'KNC', amt: 1, rate: 0 },
        { from: 'BAT', to: 'ETH', amt: 1, rate: 0 },
        { from: 'ETH', to: 'DAI', amt: 1, rate: 0 }
      ],
      swap: new SwapProviders(
        providers,
        {
          network: this.$store.state.network.type.name,
          web3: this.$store.state.web3,
          getRateForUnit: false
        },
        {
          tokensWithBalance: this.tokensWithBalance,
          online: this.$store.state.online
        }
      ),
      updatingRates: false,
      suppliedFrom: {
        symbol: 'ETH',
        name: 'Ethereum'
      },
      suppliedTo: {
        symbol: 'BTC',
        name: 'Bitcoin'
      },
      suppliedFromAmount: 0
    };
  },

  computed: {
    ...mapState(['account', 'web3', 'network', 'online']),
    sortedObject() {
      const arrayedDapp = [];
      const actualReturnedDapp = [];
      Object.keys(dapps).forEach(dapp => {
        if (dapp === 'manageEns' || dapp === 'maker')
          actualReturnedDapp.push(dapps[dapp]);
        arrayedDapp.push(dapps[dapp]);
      });
      const newestDapp = arrayedDapp.sort((a, b) => {
        return new Date(b.releaseDate) - new Date(a.releaseDate);
      })[0];
      actualReturnedDapp.push(newestDapp);
      return actualReturnedDapp;
    },
    isOnlineAndEth() {
      return this.online && this.network.type.name === 'ETH';
    }
  },
  watch: {
    ['swap.haveProviderRates']() {
      if (this.isOnlineAndEth) {
        this.haveProviderRates = this.swap.haveProviderRates;
        this.setupSwap();
      }
    },
    network() {
      setTimeout(() => {
        this.swap = new SwapProviders(
          providers,
          {
            network: this.network.type.name,
            web3: this.web3,
            getRateForUnit: false
          },
          {
            tokensWithBalance: this.tokensWithBalance,
            online: this.$store.state.online
          }
        );
      }, 500);
    }
  },
  mounted() {
    if (this.online && this.network.type.name === 'ETH') {
      this.showSwapValues = true;
    } else {
      this.showSwapValues = false;
    }
  },
  methods: {
    goTo(page, disabled) {
      if (disabled) return;
      let childIndex = -1;
      const pageInfo = this.tabData.find(entry => {
        if (entry.name === page) {
          return true;
        } else if (entry.children.length > 0) {
          const found = entry.children.findIndex(child => child.name === page);
          if (found >= 0) {
            childIndex = found;
            return true;
          }
        }
        return false;
      });
      if (childIndex >= 0) {
        if (this.online || !pageInfo.children[childIndex].onlineOnly) {
          this.$router.push({ path: pageInfo.children[childIndex].routes[0] });
        }
      } else {
        if (this.online || !pageInfo.onlineOnly) {
          this.$router.push({ path: pageInfo.routes[0] });
        }
      }
    },
    async setupSwap() {
      if (this.isOnlineAndEth) {
        for (let i = 0; i < this.swapPairs.length; i++) {
          const swappers = await this.swap.standAloneRateEstimate(
            this.swapPairs[i].from,
            this.swapPairs[i].to,
            this.swapPairs[i].amt
          );
          if (this.isOnlineAndEth) {
            if (swappers) {
              this.$set(
                this.swapPairs[i],
                'rate',
                toBigNumber(swappers[0].rate).toFixed(4)
              );
            }
          }
        }
      }
    },
    showSwapWidget(vals) {
      if (this.isOnlineAndEth) {
        this.$eventHub.$emit(
          'showSwapWidget',
          this.account.address,
          vals.from,
          vals.to,
          vals.amt
        );
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'DashboardContainer.scss';
</style>
